import { MainInfoData } from './type';

type MainInfoApiResponse = Omit<MainInfoData, 'error'> & { error: string | null | [null] };

export const fetchMainInfo = async (sessionId: string) => {
	try {
		const formData = new FormData();

		formData.append('method', 'sum_info');
		formData.append('session_id', sessionId);

		const API = import.meta.env.VITE_API_BASE_URL;
		const url = `${API}/carbon`;

		const response = await fetch(url, {
			method: 'POST',
			body: formData,
		});

		if (!response.ok) {
			throw new Error(`HTTP error! status: ${response.status}`);
		}

		const data = (await response.json()) as MainInfoApiResponse;

		return { ...data, error: Array.isArray(data.error) ? null : data.error };
	} catch (error) {
		console.error('Fetch error:', error);
		throw error;
	}
};
